function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6639 3.61804C11.2206 2.52716 12.7794 2.52716 13.3361 3.61804L15.2504 7.36913C15.4683 7.79621 15.8773 8.09336 16.3509 8.16867L20.5099 8.83013C21.7194 9.0225 22.2011 10.5049 21.3356 11.3715L18.3597 14.3513C18.0209 14.6905 17.8647 15.1713 17.9394 15.6449L18.5955 19.8048C18.7863 21.0146 17.5253 21.9308 16.4337 21.3755L12.6801 19.466C12.2528 19.2486 11.7472 19.2486 11.3199 19.466L7.56633 21.3755C6.47474 21.9308 5.21371 21.0146 5.40452 19.8048L6.06065 15.6449C6.13535 15.1713 5.97913 14.6905 5.64031 14.3513L2.66436 11.3715C1.79891 10.5049 2.28058 9.0225 3.4901 8.83013L7.64915 8.16867C8.12268 8.09336 8.53167 7.79621 8.74962 7.36913L10.6639 3.61804Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.0597b16d.svg";
export { ForwardRef as ReactComponent };